export const APPEARANCES = {
  bold: 'bold',
  medium: 'medium',
};

export const IDS = {
  legacy: 'Legacy',
  latitude: 'Latitude',
  wl: 'WL',
};
